<template>
    <div class="animated fadeIn">
        <div id="custom_backdrop"></div>
        <div class="row pageinfo">
            <b-col cols="4" lg="6">
                <h2>Requested Hauls</h2>
            </b-col>
        </div>

    <!-- Filters block-->
        <div class="filters pb-2">
            <b-row>
                <b-col order="1" order-md="1" cols="8" sm="6" md="4" lg="2" class="my-1">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <b-form-input v-model="filter" placeholder="Search" />
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </div>
                    </div>
                </b-col>
            </b-row> 

            <b-row>
                <b-col v-if="role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager'" class="my-1" title="Energy Companies" sm="6" md="3" lg="2">
                    <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.energy_company_name" >
                        <b-dropdown-item @click="ecFilter('All Energy Companies', 0)">All Energy Companies</b-dropdown-item>
                        <b-dropdown-item v-for="energy_company_filter in energy_companies_filter" @click="ecFilter(energy_company_filter.company_name, energy_company_filter.id)">{{energy_company_filter.company_name}}</b-dropdown-item>
                    </b-dropdown>
                </b-col>
                <b-col class="my-1 f6" sm="6" md="3" lg="2">
                    <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filters_save.load_name" title="Load Locations">
                        <b-dropdown-item @click="lFilter('All Loads', 0)">All Loads</b-dropdown-item>
                        <b-dropdown-item v-for="load_location_filter in load_locations_filter" @click="lFilter(load_location_filter.legal_location, load_location_filter.id)">{{load_location_filter.legal_location}}</b-dropdown-item>
                    </b-dropdown>
                </b-col>
                <b-col class="my-1 f7" sm="6" md="3" lg="2">
                    <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.unload_name" title="Unload Locations">
                        <b-dropdown-item @click="uFilter('All Unloads', 0)">All Unloads</b-dropdown-item>
                        <b-dropdown-item v-for="unload_location_filter in unload_locations_filter" @click="uFilter(unload_location_filter.legal_location, unload_location_filter.id)">{{unload_location_filter.legal_location}}</b-dropdown-item>
                    </b-dropdown>
                </b-col>
                <b-col v-if="role =='super_admin' ||  role =='trucking_company_admin' || role =='trucking_operational_manager'" class="my-1" title="Fluid Types" sm="6" md="3" lg="2">
                    <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.fluid_type_name" >
                        <b-dropdown-item @click="ftFilter('All Fluid Types', 0)">All Fluid Types</b-dropdown-item>
                        <b-dropdown-item v-for="fluid_type_filter in fluid_types_filter" @click="ftFilter(fluid_type_filter.name, fluid_type_filter.id)">{{fluid_type_filter.name}}</b-dropdown-item>
                    </b-dropdown>
                </b-col>
                <b-col class="my-1 f9" title="Initial Date" sm="6" md="4" lg="3">
                    <b-form-input id="haul_start_datetime" v-model="filter_by.initial_date" @change="iFilter" type="date" ></b-form-input>
                </b-col>
                <b-col class="my-1 lg-3 f10" title="End date" sm="6" md="4" lg="3">
                    <b-form-input id="haul_end_datetime" v-model="filter_by.end_date" @change="eFilter" type="date"></b-form-input>
                </b-col>       
                <b-col class="my-1 lg-3 f11 " style=" padding-top: 3px; padding-bottom: 3px;" sm="6" md="4" lg="3">
                    <b-button block style="height: 100%;" @click="clearFilters()">Clear</b-button>
                </b-col> 
            </b-row>
        </div>

    <!-- Main table block -->
        <div class="card">
            <div class="card-body p-0">
                <b-row v-if="loadingData">
                    <b-col cols="12" sm="12" md="12" lg="12">
                        <p class="text-center"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br> Loading data... </p>
                    </b-col>
                </b-row>
                <div v-else class="table-responsive p-0 m-0">
                    <b-table 
                        class="animated fadeIn" 
                        striped 
                        bordered
                        hover 
                        show-empty 
                        stacked="md" 
                        :items="items" 
                        :fields="fields" 
                        :current-page="currentPage" 
                        :per-page="perPage" 
                        @filtered="onFiltered" 
                        :filter="filter"      
                    >
                        <template slot="action" slot-scope="row">
                            <b-button v-if="row.item.status_id==4" size="sm" @click="adjust(row.item, row.index)" class="mr-1">
                            Accept
                            </b-button>    
                            <b-button v-else size="sm" @click="adjust(row.item, row.index)" class="mr-1">
                            Reject
                            </b-button> 
                        </template>
                    </b-table>
        <!-- User Interface controls -->
                    <div class="table-controls">
                        <b-row>
                        <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend"> </div>
                                <b-select :options="pageOptions" v-model="perPage" />
                            </div>
                        </b-col>
                        <b-col lg="10" md="10" sm="12" class="my-1">
                            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="mt-0 mb-3 pull-right" />
                        </b-col>
                        </b-row>
                    </div>
        <!-- End User Interface controls-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import haul_service from './haul_service'
  import moment from 'moment';

  Vue.use(VueSweetalert2)
  
  const items = []
  export default {
    name: 'RequestHauls_tc',
    created: function() {
      this.getAll()
    },
    data() {
      return {
        loadingData                 : true,
        items                       : items,
        totalRows                   : items.length,
        fields: [
        {
          key: 'haul_id',
          label: 'Id',
          sortable: true
        },{
          key: 'energy_company',
          label: 'Energy Company',
        //}, {
        //  key: 'trucking_company',
        //  label: 'Trucking Company',
        }, {
          key: 'operating_area',
          label: 'Operating Area',
        },
        {
          key: 'load_location',
          label: 'Load',
        }, {
          key: 'unload_location',
          label: 'Unload',
          sortable: false,
        }, {
          key: 'volume',
          label: 'Volume',
          sortable: false,
          formatter: (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³' }
        },
        {
          key: 'dispatch_date',
          label: 'Dispatch Date',
          sortable: false,
          formatter:(value) => { return moment(value).format("MMM DD, YYYY") }
        },
        { key: 'action',
          label: 'Action'
        },
        //{
         // key: 'status',
         // label: 'Status',
        //}
        ],
        currentPage               : 1,
        perPage                   : 25,
        pageOptions               : [25, 50, 100],
        filter                    : null,
		role                      :'',
		savebtn                   :true,
        energy_company_id         :null,
        filter_by:{ "initial_date"          :   moment().startOf('week').format('YYYY-MM-DD'), 
                    "end_date"              :   moment().endOf('week').format('YYYY-MM-DD'), 
                    "trucking_company_id"   :   "", 
                    "unload_location_id"    :   "", 
                    "energy_companies_id"   :   "", 
                    "load_location_id"      :   "", 
                    "fluid_type_id"         :   ""
                },
        filters_save              : {
          energy_companies_id     : 0,
          energy_company_name     : 'All Energy Companies',
          trucking_company_id     : 0,
          trucking_company_name   : 'All Trucking Companies',
          load_location_id        : 0,
          load_name               : 'All Loads',
          fluid_type_id           : 0,
          fluid_type_name         : 'All Fluid Types',
          unload_location_id      : 0,
          unload_name             : 'All UnLoads',
          initial_date            : '',
          end_date                : '',
          sortby                  : 'haul_id',
          sortdesc                : false
        },
        newHaul: {
            energy_company_select     : [],
            trucking_company_select   : [],
            operating_area_select     : [],
            load_location_select      : [],
            unload_location_select    : [],           
            fluid_type_select         : [],
            energy_companies_id       : '',
            trucking_company_id       : '',
            operating_area_id         : '',
            load_location_id          : '',
            unload_location_id        : '',  
            fluid_type_id             : '',
            dispatch_date             : '',
            volume                    : '',
        },
        energy_companies_filter     : '',
        load_locations_filter       : '',
        unload_locations_filter     : '',
        trucking_companies_filter   : '',
        fluid_types_filter          : '',
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })

      }
    },
    methods: {
        activate_custom_backdrop() {
            this.$root.$el.classList.add("custom_backdrop_behavior");
        },
        deactivate_custom_backdrop() {
            this.$root.$el.classList.remove("custom_backdrop_behavior");
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        getAll() {
            this.items = []
            haul_service.get_request_hauls(this.filter_by)
            .then(data => {
                if (data.status == 'success') {
                    this.items      = data.hauls
                    this.newHaul.energy_company_select=data.company
                    this.getAll1()
                }
                else {
                    this.$swal(data.status, data.message, data.status)
                    this.loadingData = false
                    return
                }
                this.loadingData = false
            })
            .catch(error => {
                Vue.swal('Error', 'Server not response. ' + error, 'error')
                this.loadingData = false
            })
        },
      getAll1() {
        haul_service.getAll1()
          .then(data => {
            if (data.status == 'success') {             
                this.energy_companies_filter  = data.energy_companies_filter
                this.load_locations_filter    = data.load_locations_filter
                this.unload_locations_filter  = data.unload_locations_filter
                this.trucking_companies_filter = data.trucking_companies_filter
                this.fluid_types_filter       = data.fluid_types_filter 
  			    this.role                     = data.role
            }
            else {

              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return
            }
            this.loadingData = false
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      ecFilter(ec_filter,id) {
        this.filter_by['energy_companies_id'] = id

        if (id==0) {
          this.filter_by['energy_companies_id'] = ''
        }
        this.filters_save.energy_company_name =  ec_filter
        this.filters_save.energy_companies_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true

      },
      tcFilter(tc_filter,id) {
        this.filter_by['trucking_company_id'] = id
        if (id==0) {
          this.filter_by['trucking_company_id'] = ''
        }
        this.filters_save.trucking_company_name =  tc_filter
        this.filters_save.trucking_company_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      lFilter(l_filter,id) {
        this.filter_by['load_location_id'] = id
        if (id==0) {
          this.filter_by['load_location_id'] = ''
        }
        this.filters_save.load_name =  l_filter
        this.filters_save.load_location_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      uFilter(u_filter,id) {
        this.filter_by['unload_location_id'] = id
        if (id==0) {
          this.filter_by['unload_location_id'] = ''
        }
        this.filters_save.unload_name =  u_filter
        this.filters_save.unload_location_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      iFilter(a) {
        if (this.filter_by['end_date']=='' || !this.filter_by['end_date']) {
          this.filter_by['end_date'] = ''
          this.filters_save.end_date = ''
        }
        this.filter_by.initial_date = a
        this.filters_save.initial_date = this.filter_by.initial_date
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      eFilter(a) {
        if (this.filter_by['initial_date'] =='' || !this.filter_by['initial_date']) {
          this.filter_by['initial_date'] = ''
          //this.filters_save.initial_date = ''
        }
        this.filter_by.end_date = a
        //this.filters_save.end_date = this.filter_by.end_date
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
        ftFilter(ft_filter,id) {
            this.filter_by['fluid_type_id'] = id

            if (id==0) {
                this.filter_by['fluid_type_id'] = ''
            }
            this.filters_save.fluid_type_name =  ft_filter
            this.filters_save.fluid_type_id = id
            this.getAll()
            //this.saveFilters()
            this.loadingData = true

        },
        clearFilters() {
            this.filter_by = {  "initial_date"          : moment().startOf('week').format('YYYY-MM-DD'), 
                                "end_date"              : moment().endOf('week').format('YYYY-MM-DD'), 
                                'energy_companies_id'   : '',
                                "trucking_company_id"   : "", 
                                "load_location_id"      : "",
                                "unload_location_id"    : "",                         
                                'fluid_type_id'         : '',
            }
            this.filters_save = {
              energy_companies_id   : 0,
              energy_company_name   : 'All Energy Companies',
              trucking_company_id   : 0,
              trucking_company_name : 'All Trucking Companies',
              load_location_id      : 0,
              load_name             : 'All Loads',
              unload_location_id    : 0,
              unload_name           : 'All UnLoads',
              fluid_type_id         : 0,
              fluid_type_name       : 'All Fluid Types',
              initial_date          : '', // moment().startOf('month').format('YYYY-MM-DD'),
              end_date              : '', //moment().endOf('month').format('YYYY-MM-DD'),
            }
            this.getAll()
            this.loadingData = true
        },
        adjust(item, index) {
            let accepted = {
				'status_id': 5
            }
            if (item['status_id']==4) {        
                item.status_id       = 5
            } else {
                accepted['status_id']= 4
                item.status_id  = 4
            }
            haul_service.update_request(accepted,item['haul_id'] )
                .then((data) => {
                    if (data.status == 'success') {
                        Vue.swal(data.status, data.message, data.status)
                        console.log('good')
                    }else{
                        Vue.swal(data.status, data.message, data.status)
                    }
            })
        },
  }
}
</script>

<style lang="scss" scoped>
  .show-details-cell{
    font-weight: 500;
    cursor: pointer;
  }
  .table-controls{
    padding: 14px 16px 0 16px;
  }
  /deep/ .table{
    margin: 0;
    td{
      white-space: nowrap;
      vertical-align: middle;
    }
    th{
      white-space: nowrap;
      vertical-align: middle;
    }
    td> div{
      line-height: 1;
    }
    .b-table-details> td {
      background-color: #FFFDF0;
    }
    .b-table-details h6{
      padding: 0;
      margin: 0;
      font-size: 0.8rem;
      line-height: 16px;
      margin-bottom: 8px;
      color: #676973;
    }
    .b-table-details p{
      font-size: 16px;
      color: #3A3E4D;
      padding: 0;
      margin: 0;
      line-height: 18px;
      margin-bottom: 16px;
    }
    .details-container{
      position: relative;
      white-space: normal; 
      display: flex; 
      flex-direction: row;
      flex-wrap: nowrap; 
      justify-content: flex-start;
      .item{
        padding-left: 10px;
        padding-right: 10px;
      }
      .item.location{
        width: 180px;
      }
      .item.ticket{
        width: 130px;
      }
      .item.date{
        width: 180px;
      }
      .item.volume{
        min-width: 100px;
      }
      &::after{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 20px;
        height: 100%;
        border-top: 1px solid #bcbcbc;
      }
      &::before{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 2px;
        height: 100%;
        border-left: 1px solid #bcbcbc;
      }
    }
    .details-container:last-child::before{
      display: none;
    }
  }
  /deep/ .btn-secondary{
    background: #ffffff;
  }
  /deep/ .custom-control {
    margin: 0;
    padding-left: 1rem;
  }
  /deep/ .select_column{width: 2%}
  /deep/ .bulk-action-controls{
    .dropdown{
      display: block;
      width: 100%;
    }
    .dropdown-toggle{
      display: block;
      width: 100%;
      text-align: left;
    }
    .dropdown-toggle::after {
      position: absolute;
      right: 15px;
      top: 50%;
      margin-top: -2px;
    }
    .close-controls{
      font-size: 18px; 
      font-weight: bold;
      height: 35px; 
      line-height: 14px;
      cursor: pointer;
      padding: 8px;
    }
    .btn-secondary{
      border-color: #cacaca;
    }
    .btn-select{
      height: 35px;
      margin-bottom: auto;
      margin-top: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/hauls/request_h.vue